import { render, staticRenderFns } from "./CategoryApp.vue?vue&type=template&id=a63ae85c&scoped=true"
import script from "./CategoryApp.vue?vue&type=script&lang=js"
export * from "./CategoryApp.vue?vue&type=script&lang=js"
import style0 from "./CategoryApp.vue?vue&type=style&index=0&id=a63ae85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63ae85c",
  null
  
)

export default component.exports